import './Tutorial.less';

import clsx from 'clsx';
import { dispatch } from 'nike-re-framejs';
import React, { FC, useState } from 'react';
import { Button } from '../../button/Button';
import { setTutorialStatus } from '../handlers';
import CloseIcon from '../../../icons/CloseIcon';
import { trackEvent } from '../../../analytics/gtm';
import { LOCAL_STORAGE_TUTORIAL } from '../constants';
import i18n from '../../../common/i18n';
import { SvgIcon } from '../../../icons/SvgIcon';
import { openTutorial } from '../config';

export const TutorialIntro: FC = () => {
    const handleOpenTutorial = () => {
        openTutorial();
        trackEvent('TurboLiveTutorial', 'OpenByButton');
    };
    return (
        <div className="filter-dropdown-wizard flex flex-col flex-1 px-20 py-20">
            <h2 className="c-black-100 text-bold fs-14">{i18n('tlv.filter.tutorial.title')}</h2>
            <div className="flex">
                <SvgIcon imgId="wizard-help" sizeX={'64'} sizeY={'54'} className="mt-10" />
                <div className="flex flex-1 flex-col pl-20 pr-10">
                    <span className="fs-10 mt-10 c-black-50">{i18n('tlv.filter.tutorial.description')}</span>
                    <div onClick={() => handleOpenTutorial()} className="fs-10 mt-10 c-link-default pointer">
                        {i18n('tlv.filter.tutorial.show')}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const Tutorial: FC<{
    closeModal?: any;
    tutorial: any;
    onClose?: any;
    staticUrl: any;
    mobile?: boolean;
}> = ({ closeModal, tutorial, staticUrl, mobile }) => {
    const [page, setPage] = useState(0);
    const tutorialLength = tutorial.length - 1;
    const introPage = page === 0;
    const lastPage = page === tutorialLength;
    const counter = page.toString() + '/' + tutorialLength;
    const imgUrl = `${staticUrl}/nike/cms_uploads/${tutorial[page].img}`;

    const title = i18n('nui.turbolive.tutorial.title.' + tutorial[page].seq);
    const text = i18n('nui.turbolive.tutorial.text.' + tutorial[page].seq);
    const btnTitle = introPage
        ? i18n('nui.turbolive.tutorial.button.startGuide')
        : lastPage
        ? i18n('nui.turbolive.tutorial.button.finish')
        : i18n('nui.turbolive.tutorial.button.next');

    const handleModalClose = () => {
        trackEvent('TurboLiveTutorial', 'Close', `On page`, page);
        closeModal();
    };

    const handlePageSubmiting = () => {
        if (!lastPage) return setPage(page + 1);
        if (lastPage) {
            trackEvent('TurboLiveTutorial', 'Submit', `Tutorial completed`);
            localStorage.setItem(LOCAL_STORAGE_TUTORIAL, 'completed');
            dispatch(setTutorialStatus('completed'));
            closeModal();
        }
    };

    const handlePageBack = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    return (
        <div
            className={clsx('tutorial-modal-container flex flex-col items-center justify-between', {
                'modal-container-open': true,
                'px-20 py-20': !mobile
            })}
        >
            <div className="flex justify-between items-start full-width">
                <div className={clsx('spacer', { 'mr-20': mobile })} />
                <h1 className="uppercase fs-18 text-extra-bold">{title}</h1>
                <button className={clsx('flex p-0', { 'mr-20': mobile })} onClick={handleModalClose}>
                    <CloseIcon />
                </button>
            </div>
            <div className="flex my-20 full-width">
                <img
                    className={clsx('tutorial-picture full-width', { radius: !mobile })}
                    src={`${imgUrl}`}
                    alt={tutorial[page].img}
                />
            </div>
            <p className={clsx('fs-15 c-black-50 text-center lh-1-3 mb-30 px-30 mx-20')}>{text}</p>

            <div
                className={clsx('flex items-center flex full-width', {
                    'flex-col': introPage
                })}
            >
                {page >= 1 && page <= tutorialLength ? (
                    <div
                        className={clsx({
                            'flex justify-end items-center flex-1 mr-10': !introPage,
                            'ml-20': mobile
                        })}
                    >
                        <Button
                            label={i18n('nui.turbolive.tutorial.button.back')}
                            className={clsx('grey', { 'nui-button': mobile, 'nui-button-180': !mobile })}
                            onClick={handlePageBack}
                        />
                    </div>
                ) : null}
                <div
                    className={clsx({
                        'flex justify-start items-center flex-1 mr-20 ml-10': !introPage,
                        'mr-20': mobile && !introPage
                    })}
                >
                    <Button
                        primary
                        label={btnTitle}
                        className={clsx({ 'nui-button': mobile, 'nui-button-180': !mobile })}
                        onClick={handlePageSubmiting}
                    />
                </div>

                {introPage ? (
                    <button onClick={handleModalClose} className="nui-blue-link fs-14 text-extra-bold mt-20">
                        {i18n('nui.turbolive.tutorial.skip')}
                    </button>
                ) : null}
            </div>
            {!introPage ? (
                <div className="tutorial-page-counter flex-1 text-center fs-14 text-extra-bold mt-20">{counter}</div>
            ) : null}
        </div>
    );
};
